import React from 'react';

const backdrop = (props) => {
    
    let styleCSS={};
    let backdropOutput = null;
  
    if(props.fadeAnimation && props.fadeAnimation ==='true'){
        // handle fadeIn / fadeOut animation
        styleCSS={
            transition: 'all 0.5s ease',
            visibility: props.show ? 'visible' : 'hidden',
            opacity: props.show ? 1:0
        }
        backdropOutput =  <div className="modal-backdrop" style={styleCSS} onClick={props.clicked}></div>;
    }else{
        backdropOutput =  props.show ? <div className="modal-backdrop" onClick={props.clicked}></div>:null;
    }
    
    return backdropOutput
    
}

export default backdrop;


// WEBPACK FOOTER //
// ./src/containers/UI/Backdrop/Backdrop.js